import React, { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../Assets/Memoji/4.png';
import classes from './Footer.module.css';
import Social from '../UI/Social/Social';
import Header from '../UI/Header/Header';
// import up from "../../Assets/uparrow.gif";

const Footer = () => {
  //assigning location variable
  const location = useLocation();

  //destructuring pathname from location
  const { pathname } = location;

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split('/');

  return (
    <>
      <div className={classes.footer_btn}>
        <div
          onClick={() => {
            window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });
          }}
          className={classes.footer_scrollup_btn}
        >
          <ion-icon name="arrow-up-circle"></ion-icon>
        </div>
      </div>
      <footer className={classes.footer_section}>
        <div className={classes.footer_row1}>
          <div className={classes.footer_heading}>
            <img src={logo} className={classes.footer_logo} alt="logo"></img>
            <h1 className={classes.footer_name}>
              <Header header="Om Gawande" styles={classes.footer_name} />
            </h1>
          </div>
          <div className={classes.footer_nav}>
            <ul className={classes.footer_nav_links}>
              <li className={classes.footer_nav_link}>
                <Link
                  className={
                    splitLocation[1] === '' ? classes.active : classes.footer_a
                  }
                  to="/"
                >
                  Home
                </Link>
              </li>
              <li className={classes.footer_nav_link}>
                <Link
                  className={
                    splitLocation[1] === 'about'
                      ? classes.active
                      : classes.footer_a
                  }
                  to="/about"
                >
                  About
                </Link>
              </li>
              <li className={classes.footer_nav_link}>
                <Link
                  className={
                    splitLocation[1] === 'projects'
                      ? classes.active
                      : classes.footer_a
                  }
                  to="/projects"
                >
                  Projects
                </Link>
              </li>
              <li className={classes.footer_nav_link}>
                <Link
                  className={
                    splitLocation[1] === 'experience'
                      ? classes.active
                      : classes.footer_a
                  }
                  to="/experience"
                >
                  Experience
                </Link>
              </li>
              <li className={classes.footer_nav_link}>
                <Link
                  className={
                    splitLocation[1] === 'contact'
                      ? classes.active
                      : classes.footer_a
                  }
                  to="/contact"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className={classes.footer_row2}>
          <Social y="145" width="50px" />
        </div>
        {/* <hr /> */}
        <div className={classes.footer_copyrights}>
          <div className={classes.footer_ruler}></div>
          <p className={classes.footer_copyright}>
            © Om Gawande 2022
            <br />
            All Rights Reserved.
          </p>
        </div>
      </footer>
    </>
  );
};

export default memo(Footer);
